import { render, staticRenderFns } from "./AddQuestionComponent.vue?vue&type=template&id=627855ad&scoped=true"
import script from "../js/AddPaper.js?vue&type=script&lang=js&external"
export * from "../js/AddPaper.js?vue&type=script&lang=js&external"
import style0 from "./AddQuestionComponent.vue?vue&type=style&index=0&id=627855ad&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627855ad",
  null
  
)

export default component.exports